import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';

// import { retry } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { DEFAULT_ADMIN_UNIT_ID } from '../services/login.service';
// import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // intercept(req: HttpRequest<any>, next: HttpHandler) {
    // let authService = this.injector.get(AuthService);
    const _ADType = sessionStorage.getItem('adType');

    let tId = '';
    let tName = '';
    if (_ADType === 'gapi') {
      tId = '*'; // this is handled in the api
      tName = '*';
    } else {
      tId = sessionStorage.getItem('tenantId') || this.microsoftTenantId();
      tName = sessionStorage.getItem('tenantName') || '';
    }

    let auId = sessionStorage.getItem('AUId');
    if (!auId) {
      auId = DEFAULT_ADMIN_UNIT_ID;
    }

    let authReq = req.clone({ headers: undefined });
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    // console.log('tokeniterceptor:cus intersept 1' + req.url);

    if (req.url.search('api') !== -1) {
      // console.log('tokeniterceptor:api request --' + tName);
      authReq = req.clone({
        setHeaders: {
          TenantId: tId,
          TennantName: tName,
          AdminUnitId: auId,
        },
      });
    }

    // send cloned request with header to the next handler.
    return next.handle(authReq).pipe(
      catchError(error => {
        return throwError(error);
      })
    );
  }

  private microsoftTenantId(): string {
    const msalService = this.injector.get(MsalService);
    const account =
      msalService.instance.getActiveAccount() || msalService.instance.getAllAccounts()[0];
    return account?.tenantId || '';
  }
}
